var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStrawberry = function SvgStrawberry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#strawberry_svg__a)",
    d: "M130.439 88C160.212 88 188 98.915 188 127.69S164.182 216 141.356 216 82 152.541 82 130.193 94.711 88 130.439 88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#strawberry_svg__b)",
    d: "M176.32 99.009c-7.642-3.813-9-13.906-40.2-14.119 2.018-5.709 5.052-16.777 3.663-28.871-.2-1.761-2.029-2.185-3.8-1.966-1.766.2-2.8.935-2.6 2.7 1.453 12.658-2.665 24.423-4.174 28.2-36.35.924-34.684 10.517-48.151 16.625-1.172.531 14.16 3.853 29.607-6.422 3.862-2.57 6.436-2.57 6.436-2.57s-1.287 1.285 2.575 3.854 9.01 10.276 9.01 11.56c0 0 15.447-11.56 15.447-16.7 0 0 20.6 15.414 43.767 12.845 4.051-.445-3.857-1.283-11.58-5.136"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "strawberry_svg__a",
    x1: 136.166,
    x2: 129.834,
    y1: 94.4,
    y2: 220.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "strawberry_svg__b",
    x1: 134.996,
    x2: 134.996,
    y1: 108,
    y2: 58.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#067EB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#1385B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2990BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#47A0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#6FB4D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#9FCDE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#D6EAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgStrawberry;